import React, { Fragment } from 'react';
import { Grid, Card, Label, Header } from 'semantic-ui-react';

import ConfirmationModal from '../modals/ConfirmationModal';
import RemovePassengerLabel from '../RemovePassengerLabel';
import DocumentLabels from '../DocumentLabels';
import ClaimsLabels from './ClaimsLabels';
import PersonalInformation from './PersonalInformation';
import Compensation from './Compensation';

const View = ({
  passenger,
  promoCode,
  payment,
  loa,
  contactPerson,
  claims,
  documents,
  contact,
  previewOnly,
  removable,
  loading,
  isConfirmationOpen,
  onConfirmation,
  onRemovePassenger,
  onDeleteClick,
  onEmailClick,
  createMarkup,
  onContactPersonChange,
  paxBankAccountHolder,
  donatedAmount
}) => {
  return (
    <Fragment>
      <ConfirmationModal
        question='Are you sure you want to delete this document?'
        isOpen={isConfirmationOpen}
        onConfirmation={onConfirmation}
      />
      <Card fluid color={contactPerson ? 'green' : undefined}>
        <Card.Content>
          {onRemovePassenger && removable && (
            <RemovePassengerLabel
              passenger={passenger}
              handleRemovePassenger={onRemovePassenger}
            />
          )}
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header as='h4' content='Personal Information' icon='id card' />
              </Grid.Column>
              <Grid.Column>
                <Header as='h4' content='Compensation' icon='payment' />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2} divided>
              <PersonalInformation
                passenger={passenger}
                promoCode={promoCode}
                onEmailClick={onEmailClick}
              />
              <Compensation
                passenger={passenger}
                payment={payment}
                loa={loa}
                createMarkup={createMarkup}
                paxBankAccountHolder={paxBankAccountHolder}
                donatedAmount={donatedAmount}
              />
            </Grid.Row>
            <Grid.Row columns={3}>
              <Grid.Column width={6}>
                {documents && (
                  <DocumentLabels
                    previewOnly={previewOnly}
                    documents={documents}
                    onDeleteClick={onDeleteClick}
                  />
                )}
              </Grid.Column>
              <Grid.Column width={4} textAlign='center'>
                {contact && (
                  <Label
                    style={{ cursor: previewOnly ? 'default' : 'pointer' }}
                    basic
                    value={passenger.id}
                    name='contactPerson'
                    onClick={onContactPersonChange}
                    color={!contactPerson ? 'grey' : 'green'}
                    content='Contact Person'
                  />
                )}
              </Grid.Column>
            </Grid.Row>
            {claims.length > 0 && <ClaimsLabels claims={claims} />}
          </Grid>
        </Card.Content>
      </Card>
    </Fragment>
  );
};

export default View;



// WEBPACK FOOTER //
// ./src/component/PassengerView/View.js